import { Heart16, HeartStroke16 } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './DefaultFavoriteButton.css';
import { FavoritesButtonContext } from '../../../context';

export interface IDefaultFavoriteButtonProps {
  checked: boolean;
  onButtonClick(): void;
}

export const DefaultFavoriteButton = ({ checked, onButtonClick }: IDefaultFavoriteButtonProps) => {
  const { customClass } = React.useContext(FavoritesButtonContext);
  const Icon = checked ? Heart16 : HeartStroke16;

  return (
    <button
      onClick={onButtonClick}
      className={classNames(styles['btn'], customClass ? customClass : styles['btn-default'])}
    >
      <span className={styles['btn-inner']}>
        <div className={styles['content']}>
          <span className={styles['icon']}>
            <Icon color="current_color" />
          </span>
          <span className={styles['text']}>{checked ? 'В избранном' : 'В избранное'}</span>
        </div>
      </span>
    </button>
  );
};
